<template>
  <Switcher />
  <div class="page">
    <Header />
    <Sidebar />

    <!-- Start::app-content -->
    <div class="main-content app-content">
      <div class="container-fluid pt-3">
        <slot></slot>
      </div>
    </div>
    <!-- End::app-content -->
    <Footer />
  </div>
  <BackToTop />
</template>
<script lang="ts">
import Header from "@/components/common/header.vue";
import Sidebar from "@/components/common/sidebar.vue";
import Footer from "@/components/common/footer.vue";
import Switcher from "@/components/common/switcher.vue";
import BackToTop from "@/components/common/backtotop.vue";
import PageHeader from "@/components/common/pageheader.vue";
export default {
  components: {
    Header,
    Sidebar,
    Footer,
    Switcher,
    PageHeader,
    BackToTop
  },
  setup(){
    const messages = useMessagesStore()

    return {
      messages
    }
  }
};
</script>

<style>
@import url("~/assets/css/global.css");
</style>

